<template>
    <cTable
      ref="table"
      :fields="fields"
      :modals="modals"
      :header="header"
      :methods="methods"
    >
      <template #cost="{ visible, params, close }">
        <CostPage :rows="params" :close="close" v-if="visible"/>
      </template>
      <template #income="{ visible, params, close }">
        <IncomePage :rows="params" :close="close" v-if="visible"/>
      </template>
      <template #shipInvoices="{ visible, params, close }">
        <InvoiceAttachment :rows="params" :close="close" v-if="visible"/>
      </template>
      <template #batchTime="{ visible, params, close }">
        <BatchUpdateTime  :rows="params" :close="close" v-if="visible"/>
      </template>
    </cTable>
</template>

<script>
import {
  operSeaOrder,
  getBillType,
  getContainerType,
  getShipCompany,
  getPort,
  getB2bOrderDetail,
  createBill,
  airway_number,
  add_number,
  del_number,
  relation_number,
  uploadFile, seaBoxArray, searchCustomer
} from "@/api/tracker/sea";
import {getAllClient} from "@/api/user/client";
import {
  getTransportAgent,
  getCustomer,
  getLoadType,
  importCost,
  importIncome,
} from "@/api/tracker/air";
import {getSelectType, getKeysType} from "@/api/public";
import cTable from "@/base/common/index";
import CostPage from "@/view/trackers/cost_page/index.vue";
import IncomePage from "../income/index.vue";
import InvoiceAttachment from "../../mock/invoice_attachment/index.vue"
import BatchUpdateTime from "../../mock/batch_time.vue"

export default {
  name: "seaWaybillList",
  components: {
    cTable,
    CostPage,
    IncomePage,
    InvoiceAttachment,
    BatchUpdateTime,
  },

  async created() {
    this.selData.fromStation = (await getPort({type: 1})).data.payload;
    this.selData.toStation = (await getPort({type: 2})).data.payload;
    this.selData.allClient = (await getAllClient()).data.payload.rows;
    this.selData.clearance_agent = (
      await getTransportAgent({type: 3})
    ).data.payload;
    this.selData.baoguan_agent = (await getTransportAgent()).data.payload;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "fromStation") item.options = this.selData.fromStation;
      if (item.key === "toStation") item.options = this.selData.toStation;
      if (item.key === "sea_agent") item.options = this.selData.clearance_agent;
      if (
        item.key === "baoguan_agent" ||
        item.key === "clearance_agent_id" ||
        item.key === "delivery" ||
        item.key === "safety_agent"
      )
        item.options = this.selData.baoguan_agent;
      if (item.key == "client_id") item.options = this.selData.allClient;
    });
  },
  methods: {},
  data() {
    let that = this;
    return {
      selData: {
        toStation: [],
        fromStation: [],
        clearance_agent: [],
        baoguan_agent: [],
      },
      showBatchTimeModal: false,
      title: "",
      methods: {
        list: (p) => {
          p["method"] = p["method"] ? p["method"] : "get";
          return operSeaOrder(p);
        },
        createBill,
        getSelectType,
        getKeysType,
        getCustomer,
        getB2bOrderDetail,
        importCost,
        importIncome,
        airway_number,
        add_number,
        del_number,
        relation_number,
        // getZhongGangList,
        // getZhongGangCount
      },
      modals: {
        uploadBox: {
          footer: {
            ok: {
              name: () => this.$t("updateFile")
            },
            cancel: {}
          },
          methods: {
            ok({list}) {
              this.$Spin.show()
              this.$page.getModal("uploadBox").disabledConfirm = true;
              let data = new FormData();
              for (var i = 0; i < list.length; i++) {
                data.append("files[]", list[i].file); // 文件对象
              }
              data.append('id', this.$page.getModal("uploadBox").attachmentLinkedId)
              data.append('prefix', 'Sea_')

              uploadFile(data).then(res => {
                this.$Spin.hide()
                if (res.data.status) {
                  this.$Message["success"]({
                    background: true,
                    content: res.data.msg
                  });
                  this.$page.getModal("uploadBox").disabledConfirm = false;
                  this.$page.getModal("uploadBox").list = res.data.payload;
                  this.$page.getList();
                } else {
                  this.$Message.error({
                    content: res.data.msg,
                    duration: 50000,
                  })
                }

              })
            }
          },
          config: {
            modalBind: {
              width: 960,
              draggable: true,
              maskClosable: false
            },
            modalContentBind: {
              style: {
                height: "500px"
              }
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            }
          },
          grid: [{files: 24}],
          fields: [
            {
              key: "files",
              component: "Upload",
              bind: {
                type: "drag",
                accept: ".xlsx,.xls"
              },
              methods: {
                beforeUpload: ({file}) => {
                  this.$refs["table"].getModal("uploadBox").list.push({file, status: undefined, name: file.name});
                  this.$refs["table"].getModal(
                    "uploadBox"
                  ).disabledConfirm = false;
                  return false;
                }
              }
            }
          ],
          table: {
            config: {
              height: 300
            },
            fields: [
              {
                name: () => this.$t("柜号"),
                key: "mawb",

                minWidth: 140
              },
              {
                name: () => this.$t("fileName"),
                key: "name",

                minWidth: 140
              },
              {
                name: () => this.$t("updateFile") + this.$t("exlType"),

                key: "status",
                minWidth: 80,
                render(h, {row}) {
                  return h(
                    "span",
                    {
                      style: {
                        color:
                          row.status != undefined
                            ? row.status
                              ? "green"
                              : "red"
                            : "blue"
                      }
                    },
                    row.status != undefined
                      ? row.status
                        ? this.$t("updateFile") + this.$t("success")
                        : this.$t("updateFile") + this.$t("error")
                      : this.$t("preparing")
                  );
                }
              },
              {
                name: () => this.$t("下载地址"),
                key: "downloadUri",
                minWidth: 110,
                render(h, {row}) {
                  if (row.downloadUri && row.downloadUri.length > 0) {
                    return h('Button', {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          window.open(row.downloadUri);
                        }
                      }
                    }, '点击下载')
                  }
                  return '-'
                }
              },
              {
                name: () => this.$t("预览地址"),

                key: "previewUri",
                minWidth: 110,
                render(h, {row}) {
                  if (row.previewUri && row.previewUri.length > 0) {
                    return h('Button', {
                      props: {
                        type: 'success',
                        size: 'small'
                      },
                      on: {
                        click: () => {
                          window.open(row.previewUri);
                        }
                      }
                    }, '点击预览')
                  }
                  return '-'
                }
              },
              {
                name: () => this.$t("operate"),

                key: "user",
                minWidth: 110
              },
              {
                name: () => this.$t("updateFile") + this.$t("date"),

                key: "date",
                minWidth: 170
              },
              {
                name: () => this.$t("operation"),

                width: 60,
                render(h, {row, index}) {
                  return h("Icon", {
                    props: {type: row && !row.status ? "md-trash" : ""},
                    on: {
                      click: () => {
                        if (row && !row.status) this.list.splice(index, 1);
                      }
                    }
                  });
                }
              }
            ]
          }
        },
        shipInvoices: {
          contentSlot: "shipInvoices",
          config: {
            modalBind: {
              width: 1020,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => false,
          },
        },
        out: {
          methods: {
            ok({close, row}) {
              let ids = this.selectAll.map((t) => t.value);
              if (ids.length === 0)
                return this.$Message.error({
                  content:
                    this.$t("select") +
                    this.$t("MoveOut") +
                    this.$t("Odd_Numbers"),
                  background: true,
                });
              this.$page
                .handleRequestMethods(
                  "del_number",
                  {id: row.mawb, ids},
                  true,
                  true
                )
                .then((res) => {
                  close();
                });
            },
          },
          config: {
            title: this.$t("MoveOut") + this.$t("Odd_Numbers"),
            modalBind: {
              width: 600,
            },
          },
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
              },
              {
                name: () => this.$t("Odd_Numbers"),
                key: "label",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        orders: {
          methods: {
            ok({close, row}) {
              let ids = this.selectAll.map((t) => t.value);
              if (ids.length === 0)
                return this.$Message.error({
                  content:
                    this.$t("select") +
                    this.$t("MoveIn") +
                    this.$t("Odd_Numbers"),
                  background: true,
                });
              this.$page
                .handleRequestMethods(
                  "add_number",
                  {id: row.mawb, ids},
                  true,
                  true
                )
                .then((res) => {
                  close();
                });
            },
          },
          config: {
            title: this.$t("MoveIn") + this.$t("Odd_Numbers"),
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          grid: [{airway_number: 24}],
          fields: [
            {
              key: "airway_number",
              name: () => this.$t("markField"),
              component: "Input",
              bind: {
                type: "textarea",
                rows: 4,
              },
              placeholder() {
                return this.$t("enter") + this.$t("markField");
              },
              methods: {
                "on-blur"({value, fields}) {
                  fields.find((t) => {
                    this.$page
                      .handleRequestMethods("airway_number", {
                        airway_number: value,
                      })
                      .then((res) => {
                        this.$modal.list = res.payload;
                        this.$forceUpdate();
                      });
                  });
                },
              },
            },
          ],
          table: {
            config: {
              height: 500,
            },
            fields: [
              {
                type: "checkbox",
                align: "center",
                width: 60,
              },
              {
                name: () => this.$t("Odd_Numbers"),
                key: "label",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        uploadMsg: {
          config: {
            title: this.$t("updateFile") + this.$t("error_mes"),
            modalBind: {
              width: 500,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("error_mes"),
                key: "msg",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        seaIncome: {
          contentSlot: "income",
          config: {
            modalBind: {
              width: 70,
              draggable: true,
              sticky: true,
            },
            // modalContentBind: {
            //   style: {
            //     height: "600px"
            //   }
            // }
          },
          footer: {
            show: () => false,
          },
        },
        openCost: {
          contentSlot: "cost",
          config: {
            modalBind: {
              styles: {
                top: "30px",
              },
              width: 90,
              draggable: true,
              sticky: true,
            },
            // modalContentBind: {
            //   style: {
            //     height: "800px"
            //   }
            // }
          },
          footer: {
            show: () => false,
          },
        },
        analysis: {
          methods: {
            ok({row, close}) {
              this.$page
                .handleRequestMethods("exportThatDay", row)
                .then((e) => {
                  window.open(this.$globalUrl + e.payload);
                  close();
                });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: 400,
            },
            formBind: {
              labelWidth: 100,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              time: [
                {
                  required: true,
                  type: "date",
                  message: "analysis date cannot be empty",
                  trigger: "change",
                },
              ],
            },
          },
          grid: [{time: 24}],
          fields: [
            {
              name: () => this.$t("analysisDate"),
              key: "time",
              component: "DatePicker",
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("start") +
                  this.$t("date") +
                  this.$t("time")
                );
              },
              bind: {
                type: "date",
                options: {
                  disabledDate(time) {
                    return time.getTime() > Date.now();
                  },
                },
              },
              methods: {
                format({searchForm, value, newFormData}) {
                  return value
                    ? this.format.dateFormat(value, "YYYY-MM-DD")
                    : "";
                },
              },
            },
          ],
        },
        update: {
          methods: {
            ok({row, close}) {
              row["method"] = "put";
              this.$page.handleRequestMethods("list", row, true).then((e) => {
                this.$page.getList();
                close();
              });
            },
          },
          footer: {
            ok: {},
            cancel: {},
          },
          config: {
            modalBind: {
              width: "80%",
              styles: {
                top: "20px",
              },
            },
            formBind: {
              labelWidth: 150,
            },
            rowBind: {
              gutter: 13,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              client_id: [
                {
                  required: true,
                  type: "number",
                  message: "clearance agent cannot be empty",
                  trigger: "blur",
                },
              ],
              // clearance_agent_id: [
              //   {
              //     required: true,
              //     type: "number",
              //     message: "clearance agent cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              booking_number: [
                {
                  required: true,
                  type: "string",
                  message: "clearance agent cannot be empty",
                  trigger: "blur",
                },
              ],
              from_station: [
                {
                  required: true,
                  type: "string",
                  message: "from Station cannot be empty",
                  trigger: "change",
                },
              ],
              to_station: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              dept_date: [
                {
                  required: true,
                  type: "date",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              expected_date: [
                {
                  required: true,
                  type: "date",
                  message: "to Station cannot be empty",
                  trigger: "change",
                },
              ],
              flight: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              // load_type: [
              //   {
              //     required: true,
              //     type: "string",
              //     message: "to Station cannot be empty",
              //     trigger: "blur"
              //   }
              // ],
              mawb: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              number_of_bags: [
                {
                  required: true,
                  type: "number",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              issue_mode: [
                {
                  required: true,
                  type: "string",
                  message: "to Station cannot be empty",
                  trigger: "blur",
                },
              ],
              weight: [
                {
                  required: true,
                  type: "string",
                  message: "weight cannot be empty",
                  trigger: "blur",
                },
              ],
              volume: [
                {
                  required: true,
                  type: "string",
                  message: "volume cannot be empty",
                  trigger: "blur",
                },
              ],
              items: [
                {
                  required: true,
                  type: "number",
                  message: "items cannot be empty",
                  trigger: "blur",
                },
              ],
              air_line: [
                {
                  required: true,
                  type: "string",
                  message: "air line cannot be empty",
                  trigger: "blur",
                },
              ],
              seal: [
                {
                  required: true,
                  type: "string",
                  message: "air line cannot be empty",
                  trigger: "blur",
                },
              ],
              goods_name: [
                {
                  required: true,
                  type: "string",
                  message: "air line cannot be empty",
                  trigger: "blur",
                },
              ],
              shipping_company: [
                {
                  required: true,
                  type: "string",
                  message: "air line cannot be empty",
                  trigger: "blur",
                },
              ],
            },
          },
          grid: [
            {client_id: 7, mawb: 7, booking_number: 7},
            {from_station: 7, to_station: 7, dept_date: 7},
            {expected_date: 7, depart_date: 7, arrival_date: 7},
            {clearance_date: 7, issue_mode: 7, cabinet_type: 7},
            {load_type: 7, weight: 7, volume: 7},
            {items: 7, seal: 7, goods_name: 7},
            {shipping_company: 7, sea_agent: 7, update_tracker: 7},
            {baoguan_agent: 7, clearance_agent_id: 7, delivery: 7},
            {safety_agent: 7, file_agent: 7, loading_agent: 7},
            {inbound_time: 7, remarks: 14},
          ],
          fields: [
            {
              key: "client_id",
              name: () => this.$t("clientName"),
              component: "Select",
              disabled: ({row, index}) => {
                return row.client_id ? true : false;
              },
              placeholder() {
                return this.$t("enter") + this.$t("clientName");
              },
              options: [],
              config: {label: "account", value: "id"},
              // methods: {
              //   async list({ field, row }) {
              //     let res = (await getAllClient()).data.payload;
              //     field.options = res;
              //     this.$forceUpdate();
              //   }
              // }
            },
            {
              key: "mawb",
              name: () => this.$t("cabinetNumber"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("cabinetNumber");
              },
              disabled: true,
            },
            {
              key: "booking_number",
              name: () => this.$t("booking_number"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("booking_number");
              },
              // disabled: true
            },
            {
              key: "from_station",
              name: () => this.$t("from_station"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("from_station");
              },
              options: [],
            },
            {
              key: "to_station",
              name: () => this.$t("to_station"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("to_station");
              },
              options: [],
            },
            {
              key: "expected_date",
              name: () => this.$t("expected_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("expected_date");
              },
            },
            {
              key: "dept_date",
              name: () => this.$t("dept_date"),
              component: "DatePicker",
              disabledDate: true,
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("dept_date");
              },
            },
            {
              key: "depart_date",
              name: () => this.$t("depart_date"),
              component: "DatePicker",
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("depart_date");
              },
            },
            {
              key: "arrival_date",
              name: () => this.$t("arrival_date"),
              component: "DatePicker",
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("arrival_date");
              },
            },
            {
              key: "inbound_time",
              name: () => this.$t("到仓时间"),
              component: "DatePicker",
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("到仓时间");
              },
            },
            {
              key: "clearance_date",
              name: () => this.$t("clearance_date"),
              component: "DatePicker",
              bind: {
                type: "datetime",
              },
              placeholder() {
                return this.$t("enter") + this.$t("clearance_date");
              },
            },
            {
              key: "load_type",
              name: () => this.$t("load_type"),
              component: "Select",
              placeholder() {
                return this.$t("enter") + this.$t("load_type");
              },
              // disabled: ({ row, index }) => {
              //   return row.load_type ? true : false;
              // },
              methods: {
                async list({field, searchForm}) {
                  let res = (await getLoadType()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
            {
              key: "issue_mode",
              name: () => this.$t("billingMethod"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("billingMethod");
              },
              options: [],
              methods: {
                async list({field, searchForm}) {
                  let res = (await getBillType()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                },
              },
              // disabled: true
            },
            // {
            //   key: "shipping_mode",
            //   name: () => this.$t("shipping_mode"),
            //   component: "Input",
            //   placeholder() {
            //     return this.$t("enter") + this.$t("shipping_mode");
            //   },
            //   disabled: true
            // },
            {
              key: "weight",
              name: () => this.$t("Weight"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("Weight");
              },
            },
            {
              key: "volume",
              name: () => this.$t("size") + "(CBM)",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("size") + "(CBM)";
              },
            },
            {
              key: "items",
              name: () => this.$t("invoicePCS"),
              component: "InputNumber",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              bind: {
                style: "width:100%",
              },
            },
            {
              key: "sea_agent",
              name: () => this.$t("shipAgent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("shipAgent");
              },
              // disabled: ({ row, index }) => {
              //   return row.sea_agent ? true : false;
              // },
              // disabled: true
            },
            {
              key: "clearance_agent_id",
              name: () => this.$t("clearagent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("clearagent");
              },
              // disabled: ({ row, index }) => {
              //   return row.clearance_agent_id ? true : false;
              // },
              // disabled: true
            },
            {
              key: "delivery",
              name: () => this.$t("distribution_agent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("distribution_agent");
              },
              // disabled: ({ row, index }) => {
              //   return row.delivery ? true : false;
              // },
              // disabled: true
            },
            {
              key: "safety_agent",
              name: () => this.$t("safetyAgent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("safetyAgent");
              },
              // disabled: ({ row, index }) => {
              //   return row.safety_agent ? true : false;
              // },
              // disabled: true
            },
            {
              key: "baoguan_agent",
              name: () => this.$t("TrailerCustomsBroker"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("TrailerCustomsBroker");
              },
              // disabled: ({ row, index }) => {
              //   return row.baoguan_agent ? true : false;
              // },
              // disabled: true
            },
            {
              key: "file_agent",
              name: () => this.$t("fileAgent"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$t("select") + this.$t("fileAgent");
              },
              // disabled: ({ row, index }) => {
              //   return row.baoguan_agent ? true : false;
              // },
              // disabled: true
            },
            {
              key: "loading_agent",
              name: () => this.$tz("装柜,代理"),
              component: "Select",
              options: [],
              placeholder() {
                return this.$tz("装柜,代理");
              },
            },
            {
              key: "cabinet_type",
              name: () => this.$t("cabinet_type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("cabinet_type");
              },
              options: [],
              methods: {
                async list({field, searchForm}) {
                  let res = (await getContainerType()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
            {
              key: "seal",
              name: () => this.$t("seal"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("seal");
              },
            },
            {
              key: "goods_name",
              name: () => this.$t("productName"),
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("productName");
              },
            },
            {
              key: "shipping_company",
              name: () => this.$t("shipping_company"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("shipping_company");
              },
              options: [],
              methods: {
                async list({field, searchForm}) {
                  let res = (await getShipCompany()).data.payload;
                  field.options = res;
                  this.$forceUpdate();
                },
              },
            },
            {
              key: "remarks",
              name: () => this.$t("Remarks"),
              component: "Input",
              bind: {
                type: "textarea",
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              },
            },
            {
              key: "update_tracker",
              name: () =>
                this.$t("update") + " " + this.$t("trajectory") + "GIL",
              component: "Radio",
              bind: {
                border: true,
              },
              options: [
                {label: this.$t("YES"), value: "YES"},
                {label: this.$t("NO"), value: "NO"},
              ],
              default: "NO",
            },
          ],
          table: {
            config: {
              height: 300,
            },
            fields: [
              {
                name: () => this.$t("orderNum"),
                key: "airway_number",
                header: {
                  copy: true,
                },
                copy: true,
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("orderQuantity"),
                key: "shipment_number",
                tooltip: true,
                minWidth: 100,
              },
              {
                name: () => this.$t("orderOutboundQuantity"),
                key: "outbound_number",
                tooltip: true,
                minWidth: 100,
              },
            ],
          },
        },
        batchTime: {
          contentSlot: "batchTime",
          config: {
            modalBind: {
              width: 480,
              draggable: true,
              sticky: true,
            },
          },
          footer: {
            show: () => false,
          },
        }
      },
      header: {
        searchs: [
          {
            key: "dateType",
            placeholder() {
              return this.$t("select") + this.$t("date") + this.$t("type");
            },
            component: "Select",
            options: [],
            methods: {
              async list({field, searchForm}) {
                let res = (await getSelectType(["SEA_EXTRACT_SELECT_TYPE"]))
                  .data.payload["SEA_EXTRACT_SELECT_TYPE"];
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("start") +
                this.$t("date") +
                this.$t("time")
              );
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              "on-change"({searchForm}) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              },
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
            },
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("select") + this.$t("end") + this.$t("date");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: "175px",
              },
            },
            methods: {
              // format({ searchForm, value, newFormData }) {
              //   return value ? this.format.dateFormat(value, "YYYY-MM-DD") : "";
              // }
              "on-change"({searchForm}) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              },
            },
          },

          {
            key: "fromStation",
            placeholder() {
              return this.$t("select") + this.$t("from_station");
            },
            component: "Select",
            options: [],
          },
          {
            key: "toStation",
            placeholder() {
              return this.$t("select") + this.$t("to_station");
            },
            component: "Select",
            options: [],
          },
          // {
          //   key: "status",
          //   placeholder() {
          //     return this.$t("select") + this.$t("finish") + this.$t("exlType");
          //   },
          //   component: "Select",
          //   config: {
          //     label({ row }) {
          //       return this.$t(row.label);
          //     }
          //   },
          //   options: [],
          //   methods: {
          //     async list({ field, searchForm }) {
          //       let res = (await getSelectType(["COMPLETION_STATUS"])).data
          //         .payload["COMPLETION_STATUS"];
          //       field.options = res;
          //       this.$forceUpdate();
          //     }
          //   }
          // },
          {
            key: "costType",
            placeholder() {
              return this.$t("whether") + this.$t("costEntry");
            },
            component: "Select",
            config: {
              label({row}) {
                return this.$t(row.label);
              },
            },
            options: [
              {
                label: "YES",
                value: "YES",
              },
              {
                label: "NO",
                value: "NO",
              },
            ],
          },
          {
            key: "client_id",
            component: "AutoComplete",
            placeholder() {
              return "请输入客户账号";
            },
            clearable: true,
            data: [],
            bind: {
              style: "width:150px",
            },
            config: {label: "account", value: "id"},
            // methods: {
            //   async list({ field, row }) {
            //     let res = (await getAllClient()).data.payload.rows;
            //     field.options = res;
            //     this.$forceUpdate();
            //   }
            // }
            data: [],
            onSearch: ({value, item}) => {
              if (value.length >= 2) {
                searchCustomer(value).then(res => {
                  item.data = res.data.payload
                })
              }
            }
          },
          {
            key: "sea_agent",
            placeholder() {
              return this.$t("select") + this.$t("shipAgent");
            },
            component: "Select",
            options: [],
          },
          {
            key: "baoguan_agent",
            placeholder() {
              return this.$t("select") + this.$t("TrailerCustomsBroker");
            },
            component: "Select",
            options: [],
          },
          {
            key: "clearance_agent_id",
            placeholder() {
              return this.$t("select") + this.$t("clearagent");
            },
            component: "Select",
            options: [],
          },
          {
            key: "delivery",
            placeholder() {
              return this.$t("select") + this.$t("distribution_agent");
            },
            component: "Select",
            options: [],
          },
          {
            key: "safety_agent",
            placeholder() {
              return this.$t("select") + this.$t("safetyAgent");
            },
            component: "Select",
            options: [],
          },
          {
            key: "finish",
            placeholder() {
              return this.$t("whether") + this.$t("complete");
            },
            component: "Select",
            config: {
              label({row}) {
                return this.$t(row.label);
              },
            },
            options: [
              {
                label: "YES",
                value: 1,
              },
              {
                label: "NO",
                value: 2,
              },
            ],
          },
          {
            key: "keywordsType",
            placeholder() {
              return this.$t("select") + this.$t("keyword") + this.$t("type");
            },
            component: "Select",
            config: {
              label({row}) {
                return this.$t(row.label);
              },
            },
            options: [],
            methods: {
              async list({field, searchForm}) {
                let res = (await getKeysType("EXTRACT_SEA_KEYWORDS")).data
                  .payload;
                field.options = res;
                searchForm[field.key] = res[0].value;
                this.$forceUpdate();
              },
            },
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
          },
        ],
        btns: {
          list: [
            // {
            //   name: () => this.$t("export") + this.$t("analysis1"),
            //   type: "analysis",
            //   fnName: "analysisFun",
            //   bind: {
            //     type: "primary",
            //     icon: "md-download"
            //   }
            // },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download",
              },
              disabled(row) {
                return !this.selectAll.length;
              },
            },
            {
              name: () => this.$t("template") + this.$t("download"),
              btnBind: {
                // icon: "md-arrow-down",
                type: "primary",
              },
              list: [
                {
                  name: this.$t("finalCost") + this.$t("template"),
                  url: "/doc/zh-CN/sea-cost.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary",
                  },
                },
                {
                  name: this.$t("income") + this.$t("template"),
                  url: "/doc/zh-CN/income.xlsx",
                  fnName: "down",
                  size: "small",
                  bind: {
                    type: "primary",
                  },
                },
              ],
            },
            {
              name: () => this.$t("finalCost") + this.$t("import"),
              fnName: "updateFile",
              type: "importCost",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("income") + this.$t("import"),
              fnName: "updateFile",
              type: "importIncome",
              component: "Upload",
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning",
              },
            },
            {
              name: () => this.$t("batch") + this.$t("Input Time"),
              fnName: 'batchUpdateTime',
              type: 'batchUpdateTime'
            },
            {
              name: () => this.$t("createCostBill"),
              fnName: "createBill",
              type: "createBill",
              bind: {
                type: "primary",
              },
              id: 1020,
            },
          ],
          methods: {
            createBill({searchForm}) {
              this.handleRequestMethods(
                "createBill",
                searchForm,
                false,
                true
              ).then((res) => {
                this.$Message.success({
                  background: true,
                  content: res.message || res.msg || "success",
                  duration: 5,
                });
              });
            },

            batchUpdateTime({field, row}) {
              this.getModal("batchTime").open(null, function () {
                this.setTitle('批量录入轨迹时间')
              });
            },

            // analysisFun({ field, searchForm }) {
            //   this.getModal("analysis").open({}, function() {
            //     this.setTitle(this.$t("analysis"));
            //   });
            // },
            down({row, field, searchForm}) {
              window.open(this.$globalUrl + field.url);
            },
            exportFun({row, field, searchForm}) {
              this.exportExc();
            },

            updateFile({file, field, searchForm}) {
              let formData = new FormData();
              formData.append("file", file);
              formData.append("type", "1");
              this.$page
                .handleRequestMethods(field.type, formData, false, true)
                .then((res) => {
                  if (res.payload.length) {
                    this.$page.getModal("uploadMsg").open(null, function () {
                      this.setTitle(
                        this.$t("import") +
                        (field.type == "importIncome"
                          ? this.$t("income")
                          : this.$t("finalCost")) +
                        this.$t("info")
                      );
                      this.list = res.payload;
                    });
                  } else {
                    this.$Message.success(
                      this.$t("updateFile") + this.$t("success")
                    );
                  }
                });
              return false;
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60,
        },
        {
          name: () => this.$t("booking_number"),
          key: "booking_number",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("cabinetNumber"),
          key: "mawb",
          align: "center",
          minWidth: 120,
        },

        {
          name: this.$t("seaShipperName"),
          key: "client_name",
          minWidth: 100,
        },
        {
          name: this.$t("createSeaUser"),
          key: "operator_name",
          minWidth: 100,
        },
        {
          name: () => this.$t("shipAgent"),
          key: "sea_agent_name",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("TrailerCustomsBroker"),
          key: "baoguan_agent_name",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("clearagent"),
          key: "clearance_agent",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("distribution_agent"),
          key: "delivery_name",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("safetyAgent"),
          key: "safety_agent_name",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$t("fileAgent"),
          key: "file_agent_name",
          align: "left",
          minWidth: 120,
        },
        {
          name: () => this.$tz("装柜,代理"),
          key: "loading_agent_name",
          minWidth: 110,
        },

        {
          name: () => this.$t("endGang"),
          key: "to_station",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("dept_date"),
          key: "dept_date",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("expected_date"),
          key: "expected_date",
          align: "left",
          minWidth: 100,
        },
        {
          name: () => this.$t("depart_date"),
          key: "depart_date",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("arrival_date"),
          key: "arrival_date",
          align: "center",
          minWidth: 130,
        },

        {
          name: () => this.$t("clearance_date"),
          key: "clearance_date",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("seal"),
          key: "seal",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("productName"),
          key: "goods_name",
          align: "center",
          minWidth: 100,
        },

        {
          name: () => this.$t("cabinet_type"),
          key: "cabinet_type",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("shipping_company"),
          key: "shipping_company",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          width: 130,
        },
        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          width: 150,
        },
        {
          type: "btns",
          width: 300,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            // {
            //   name: () => this.$t("seaIncome"),
            //   type: "seaIncome",
            //   fnName: "seaIncome",
            //   bind: {
            //     type: ({ row }) => {
            //       return row.incomeType !== "NO" ? "warning" : "default";
            //     },
            //   },
            //   id: 836,
            // },

            {
              name: () => this.$t("shipInfo"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
              id: 797,
            },
            {
              name: () => this.$t("shipDocument"),
              type: "unboxDocument",
              fnName: "openUploadBox",
              bind: {
                type: ({row}) => {
                  return row.attachment ? "warning" : "default";
                },
              },
            },
            {
              name: () => this.$t("shipInvoices"),
              type: "success",
              fnName: "openShipInvoices",
            },
            {
              name: () => this.$t("shipCost"),
              type: "openCost",
              fnName: "openCost",
              bind: {
                type: ({row}) => {
                  return row.costType !== "NO" ? "primary" : "default";
                },
              },
              id: 832,
            },
            // {
            //   name: this.$t("MoveIn") + this.$t("Odd_Numbers"),
            //   type: "moveOrders",
            //   fnName: "orders",
            //   bind: {
            //     type: "primary",
            //   },
            //   id: 1253,
            // },
            // {
            //   name: this.$t("MoveOut") + this.$t("Odd_Numbers"),
            //   type: "moveOut",
            //   fnName: "out",
            //   bind: {
            //     type: "primary",
            //   },
            //   id: 1253,
            // },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              id: 798,
            },
          ],
          methods: {
            out({row, field}) {
              this.handleRequestMethods("relation_number", {id: row.id}).then(
                (res) => {
                  this.getModal("out").open(row, function () {
                    this.setTitle(field.name);
                    this.list = res.payload;
                  });
                }
              );
            },
            openUploadBox({field, row}) {
              seaBoxArray(row.id).then(res => {
                this.getModal("uploadBox").open(row, function () {
                  this.setTitle(row.mawb + '箱单')
                  this.list = res.data.payload
                  this.disabledConfirm = true;
                  this.attachmentLinkedId = row.id
                });
              })
            },
            openShipInvoices({field, row}) {
              this.getModal("shipInvoices").open(row, function () {
                this.setTitle(row.mawb + '报关单据')
              });
            },

            orders({field, row}) {
              this.getModal("orders").open(row, function () {
                this.setTitle(field.name);
              });
            },
            seaIncome({row}) {
              row.resType = 1;
              this.getModal("seaIncome").open(row, function () {
                this.setTitle(this.$t("seaIncome"));
              });
            },
            openCost({row}) {
              row.resType = 1;
              this.getModal("openCost").open(row, function () {
                this.setTitle(this.$t("shipCost"));
              });
            },
            async showFun({row}) {
              let res = await this.handleRequestMethods(
                "getZhongGangCount",
                row.id
              );
              this.getModal("show").open({data: res.payload.rows}, () => {
                this.getModal("show").setTitle(this.$t("show") + row.mawb);
                this.getModal("show").table.fields[0].name = () => {
                  return (
                    this.$t("orderNum") + `(${res.payload.airway_bill_total})`
                  );
                };
                this.getModal("show").table.fields[1].name = () => {
                  return (
                    this.$t("packing_number") +
                    `(${res.payload.packing_number_total})`
                  );
                };
                this.getModal("show").list = res.payload.row;
              });
            },
            async updateFun({row}) {
              let data = {
                method: "get",
                id: row.id,
              };
              // this.openLoading();
              let res = await this.handleRequestMethods(
                "list",
                data,
                false,
                true
              );
              // this.closeLoading();
              that.modals.update.fields.forEach(async (item) => {
                if (item.key === "from_station")
                  item.options = that.selData.fromStation;
                if (item.key === "to_station")
                  item.options = that.selData.toStation;
                if (item.key === "sea_agent")
                  item.options = that.selData.clearance_agent;
                if (
                  item.key === "baoguan_agent" ||
                  item.key === "clearance_agent_id" ||
                  item.key === "delivery" ||
                  item.key === "safety_agent" ||
                  item.key === "file_agent" ||
                  item.key === "loading_agent"
                )
                  item.options = that.selData.baoguan_agent;
                if (item.key == "client_id") {
                  item.options = that.selData.allClient;
                }
              });
              this.getModal("update").open(res.payload, function () {
                this.setTitle(this.$t("update"));
                this.$page
                  .handleRequestMethods(
                    "getB2bOrderDetail",
                    {id: data.id},
                    false,
                    false
                  )
                  .then((res) => {
                    this.list = res.payload;
                  });
              });
            },
            deleteFun({row}) {
              this.$Modal.confirm({
                title:
                  this.$t("whether") +
                  this.$t("confirm") +
                  this.$t("delete") +
                  this.$t("cabinetNumber") +
                  ":" +
                  row.mawb +
                  "?",
                onOk: () => {
                  row["method"] = "delete";
                  this.handleRequestMethods("list", row, true).then((res) => {
                    // this.$Message.success(res.data.msg);
                    this.getList();
                  });
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
.content {
  height: 100%;
}

/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}

.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}

.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}

.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
